import React from 'react';

import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import hotkeys from 'hotkeys-js';
import axios from 'axios';
import { isEmpty } from 'underscore';
import qs from "qs";

import { READ, WRITE } from '../Om7Sense';
import { getUnitFromPath } from '../util/topic.js';

const ALL_THR_PROPERTIES = ["wb", "wbd", "wa", "wad", "cb", "cbd", "ca", "cad"];
const ENABLED_THR_PROPERTIES_ASC = ["cb", "wb", "wa", "ca"];
export const THR_TRANSLATION_KEYS = {
    "wb": "warn_below",
    "wa": "warn_above",
    "cb": "critical_below",
    "ca": "critical_above"
};
const MAX_LENGTH_NAME = 64;

export class ThresholdsPopup extends React.Component {
    static contextTypes = {
        t: PropTypes.func.isRequired,
        p: PropTypes.object.isRequired,
        basePath: PropTypes.string
    }

    origThr = null;

    sub = null;

    constructor(props) {
        super(props);
    }

    UNSAFE_componentWillMount() {
        if (this.context.p.isAuthenticated()) {
            this.onAuthenticated();
        } else {
            this.context.p.addListener("authenticated", this.onAuthenticated);
        }
    }

    formatThrNumbers(thr) {
        for (let i in ALL_THR_PROPERTIES) {
            const prop = ALL_THR_PROPERTIES[i];
            if (thr[prop] !== undefined && thr[prop] !== null) {
                thr[prop] = this.formatNumber(thr[prop]);
            }
        }
        return thr;
    }

    getPathParam(props) {
        const path = props.match?.params?.popup_path;
        if (path) {
            return decodeURIComponent(path);
        } else if (props.match?.params?.[0]) {
            return props.match?.params?.[0]
        }
    }

    getName(props) {
        const query = qs.parse(props.location.search, { ignoreQueryPrefix: true });

        return query?.name;
    }

    onAuthenticated = () => {
        this.setMeta();
    }

    setMeta() {
        let newState;

        const p = this.context.p, t = this.context.t, self = this;

        function getMetaData(newState, path) {
            const meta = getUnitFromPath(p, t, path);
            if (!newState.unit) {
                newState.unit = meta[0];
            }
            newState.type = meta[1];

            newState.readOnly = !p.checkPermission(WRITE, path);
            newState.readable = p.checkPermission(READ, path);
        }

        // There's a few ways how the threshold value can be passed in. One is a path to a data item that we
        // need to resolve, which will be in a query currently
        let path = this.getPathParam(this.props);

        if (path) {
            axios.post('/apiv2/topic/thr', {paths: [path]}).then((response) =>  {
                let newState;
                if (response && response.data && !isEmpty(response.data)) {
                    newState = response.data[path];
                    newState.thr = p.getPath(newState.path);
                }

                if (!newState || !newState.thr) {
                    newState = {thr: {wad: 0, wbd: 0, cad: 0, cbd: 0, path: ""}, name: self.getName(self.props), rule: false};
                } else {
                    newState.thr = this.formatThrNumbers(newState.thr);
                    if (!self.isOwnRule(newState)) {
                        newState.name = self.getName(self.props);
                        newState.locked = true;
                    } else {
                        newState.name = newState.thr.name;
                    }
                    newState.rule = true;
                }
                newState.data = p.getPath(path);
                self.origThr = newState.thr;
                newState.loading = false;
    
                getMetaData(newState, path);
                self.setState(newState);
            });

        } else if (this.props.thrPath) {
            // Then there's a path that's pointing to a threshold already via props
            const thr = Object.assign({}, this.context.p.getPath("thr" + this.props.thrPath));
            thr.path = this.props.thrPath;
            newState = {thr, name: thr.name, rule: true}

            // For permissions, let's see if the user has access to the actual data item (even considering wildcards)
            const fakeDataPath = this.props.thrPath.charAt(0) === '/' ? this.props.thrPath.substring(1) : this.props.thrPath;
            getMetaData(newState, fakeDataPath);
            this.origThr = newState.thr;
        } else {
            newState = {loading: false, discarding: false, error: "unknown"};
        }
        this.setState(newState);
    }

    componentDidMount() {
        const self = this;

        hotkeys('esc', self.doClose.bind(self, false))
    }

    componentWillUnmount() {
        hotkeys.unbind("esc");
    }

    doClose = (hasChange) => {
        const doClose = () => {
            if (this.props.onClose) {
                this.props.onClose();
            } else {
                if (window.history.length > 1) {
                    if (this.props.navigate) {
                        this.props.navigate(-1);
                    } else {
                        this.props.history.goBack();
                    }
                } else {
                    window.close();
                }
            }
        }
        if (hasChange) {
            if (this.state.discarding) {
                doClose();
            } else {
                // Confirm that user wants to discard changes
                this.setState({discarding: true});
            }
        } else {
            doClose();
        }
    }

    formatNumber = (data) => {
        if (data && data.v !== undefined && data.v !== null) {
            const value = data.v;
            if (value.isNaN) {
                return 0;
            }
            return parseFloat(value).toFixed(2);
        }
        return parseFloat(data).toFixed(2);
    }

    changeEnabled = (valName, ev) => {
        const self = this;
        const isChecked = ev.target.checked;
        const update = {};
        // If enabled, filter the disabled property, otherwise the enabled prop
        const filterProperty = isChecked ? valName + "d": valName;

        this.setState((state) => {
            const newThr = {};
            for (let i in ALL_THR_PROPERTIES) {
                const key = ALL_THR_PROPERTIES[i];
                if (state.thr.hasOwnProperty(key)) {
                    if (key !== filterProperty) {
                        newThr[key] = state.thr[key];
                    }
                }
            }
            const keyAdded = isChecked ? valName : valName + "d";
            newThr[keyAdded] = state.thr[filterProperty];
            self.onThresholdEnabledChanged(valName, keyAdded, filterProperty, isChecked, newThr[keyAdded]);

            return {thr: newThr, discarding: false};
        });
    }

    /**
     * A key was removed from the dict, one was added
     */
    onThresholdEnabledChanged (valName, keyAdded, keyRemoved, wasEnable, value) {

    }

    setThresholdValue (valName, newValue) {
        const self = this;

        this.setState((state) => {
            let newThr = Object.assign({}, state.thr);
            newThr[valName] = newValue;

            return {thr: newThr, discarding: false};
        });
    }

    setThreshold = (valName, ev) => {
        let newValue = ev.target.value;
        this.setThresholdValue(valName, newValue);
    }

    setName = (ev) => {
        this.setState({ name: ev.target.value, discarding: false });
    }

    doSave = () => {
        const self = this;
        this.setState((state) => {
            const update = {};
            for (let key in state.thr) {
                if (ALL_THR_PROPERTIES.indexOf(key) !== -1 && state.thr[key] !== undefined && state.thr[key] !== null) {
                    update[key] = parseFloat(state.thr[key]);
                }
            }

            update.name = state.name;

            let savePath = "thr";
            if (this.props.match?.params?.popup_path) {
                savePath += "/" + decodeURIComponent(this.props.match.params.popup_path)
            } else {
                savePath += this.props.thrPath;
            }

            self.context.p.put(savePath, update, true).then((result) => {
                self.doClose();
            }, (err) => {
                // TODO: filter out duplicate:name
                self.setState({"error": err, "loading": false});
            });

            return {"loading": true, discarding: false};
        });
    }

    isOwnRule(thr) {
        return this.props.match?.params?.popup_path && thr.path === "thr/" + decodeURIComponent(this.props.match.params.popup_path);
    }

    doUnlock = () => {
        this.setState({locked: false,  rule: true});
    }

    renderThresholds() {
        const self = this, t = this.context.t;
        const isOwnRule = this.isOwnRule(this.state);
        const data = this.state.thr;
        const disabled = !!this.state.readOnly || this.state.loading || this.state.locked || !this.state.rule;

        const hasChange = this.origThr && (this.origThr.wa != data.wa || this.origThr.wb != data.wb || this.origThr.ca != data.ca || this.origThr.cb != data.cb || this.origThr.name != this.state.name);
        let saveLabel = t('general.button_' + (hasChange ? 'save_changes' : 'unchanged'));

        let nameOrUnlockField = null;

        if (!this.state.rule) {
            // There is no rule for this path, make the user create one with a button
            nameOrUnlockField =
                <>
                    <h4 className="rules-head">Rules</h4>
                    <div className="norule">
                        
                        { t("thresholds.info_no_rule") }
                    </div>
                    <div className="form-group">
                        
                        <button className="btn btn-primary" onClick={self.doUnlock}>{t("thresholds.button_create_new_rule_for__", {name: this.state.name})}</button>&nbsp;
                    </div>
                </>
        } else {
            // If this is not a rule specific for this path, we need to unlock to create a new rule first
            let nameError = null;
            if (!this.state.name) {
                nameError = t("general.error__cannot_be_empty", {field: t('general.name') });
            } else if (this.state.name.length > 64) {
                nameError = t("general.error__cannot_be_longer_than__", {field: t('general.name'), chars: MAX_LENGTH_NAME })
            }

            if (this.state.locked) {
                if (!this.state.readOnly) {
                    nameOrUnlockField =
                    <>
                        <div>{ t("thresholds.info_thresholds_from_rule", {name: this.origThr.name}) }</div>
                        <div className="form-group">
                            
                            <button className="btn btn-primary" onClick={self.doUnlock}>{t("thresholds.button_create_new_rule_for__", {name: this.state.name})}</button>&nbsp;
                        </div>
                    </>
                }
            } else {
                nameOrUnlockField =
                    <div className="form-group">
                        <label className="form-label" htmlFor="thr-name">{t("thresholds.title_rule_name")}</label>
                        <input disabled={disabled} onChange={self.setName} className={"form-input" + (nameError ? " is-error" : "")} value={this.state.name} type="text" id="thr-name" placeholder={t("thresholds.title_rule_name")} />
                        { nameError && 
                            <p className="form-input-hint">{nameError}</p>
                        }
                    </div>
            }
        }
        let closeButton;

        if (hasChange) {
            if (this.state.discarding) {
                closeButton = t('general.confirm_to_discard_changes');
            } else {
                closeButton = t('general.discard_changes');
            }
        } else {
            closeButton = t('general.close');
        }

        const errors = {};
        let errorCount = 0;

        const values = [], valueKeys = [];
        for (let key of ENABLED_THR_PROPERTIES_ASC) {
            if (data[key] !== undefined && data[key] !== null && data[key] !== null) {
                const floatVal = parseFloat(data[key]);
                if (isNaN(floatVal)) {
                    errors[key] = t("thresholds.error_cannot_understand_number");
                    errorCount++;
                }
                values.push(floatVal);
                valueKeys.push(key);
            }
        }

        for (let i = 0; i < values.length - 1; i++) {
            if (values[i] >= values[i + 1]) {
                errors[valueKeys[i]] = t("thresholds.error_must_be_below__", {threshold: t('thresholds.' + THR_TRANSLATION_KEYS[valueKeys[i + 1]]) });
                errorCount++;
            }
        }

        let bottomButtons = this.state.rule ? (
            <>
                <a className="btn btn-primary" disabled={!hasChange || disabled || errorCount > 0} onClick={self.doSave}>{saveLabel}</a>&nbsp;
                <a disabled={this.state.loading} className={"btn " + (this.state.discarding ? "btn-error" : "btn-link")} onClick={self.doClose.bind(this, hasChange)} aria-label="Close">{closeButton}</a>
            </>
        ) : null;

        function renderThreshold(key) {
            const disabledKey = key + "d";
            const classNames = "form-group" + (errors[key] ? " has-error" : "")
            const hasKey = (data[key] !== null && data[key] !== undefined);
            const hasDisabledKey = data[disabledKey] !== null && data[disabledKey] !== undefined

            let dataNum = hasKey ? data[key] : data[disabledKey];

            // <span className="input-group-addon">{t('thresholds.' + THR_TRANSLATION_KEYS[key])}</span>
            return (
                <>
                    <label htmlFor={"input-" + key}>{t('thresholds.' + THR_TRANSLATION_KEYS[key])}</label>
                    <div className={classNames}>
                        <div className="input-group">
                            <label className="form-checkbox">
                                <input disabled={disabled} type="checkbox" checked={hasKey ? true : false} onChange={self.changeEnabled.bind(this, key)}/>
                                <i className="form-icon"> </i>
                            </label>
                            <input id={"input-" + key} className="form-input" disabled={disabled || hasDisabledKey} type="number" step="0.1" onChange={self.setThreshold.bind(this, key)} value={dataNum}/>
                            { self.state.unit }
                        </div>
                        { errors[key] && <p className="form-input-hint">{ errors[key] }</p> }
                    </div>
                </>
            );
        }

        return (
            <>
                { nameOrUnlockField }
                { renderThreshold("ca")}
                { renderThreshold("wa")}
                { this.state.v !== undefined &&
                    <div className="currentVal">
                        { this.state.v } {this.state.unit}
                    </div>
                }
                { renderThreshold("wb")}
                { renderThreshold("cb")}
                { bottomButtons }
            </>
        );
    }

    render() {
        const thr = this.renderThresholds(), t = this.context.t;

        if (!thr) {
            return null;
        }

        return (
            <div className="modal active">
                <a onClick={self.doClose} aria-label="Close" className="modal-overlay"><i className="fa fa-close" /></a>
                <div className="modal-container modal-small">
                    <div className="modal-header">
                        <div className="modal-title h5">{t("thresholds.title_setup_rule_for__", {name: this.state.name})}</div>
                    </div>
                    <div className="modal-body">
                        <form className="form-horizontal">
                            { thr }
                        </form>
                    </div>
                </div>
            </div>
        );
    }
};
